var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8ShoppingBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.734,
    height: 20.554,
    viewBox: "0 0 18.734 20.554",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-shopping-bag",
    d: "M15.067,3A4.228,4.228,0,0,0,10.85,7.216H9.426A1.854,1.854,0,0,0,7.592,8.864L6.237,21.513h0a1.859,1.859,0,0,0,1.834,2.04H23.116a1.859,1.859,0,0,0,1.834-2.041L23.6,8.864a1.854,1.854,0,0,0-1.834-1.648H20.337V8.8h1.425a.256.256,0,0,1,.263.236l1.355,12.649a.251.251,0,0,1-.263.291H8.071a.251.251,0,0,1-.262-.291h0L9.163,9.033A.256.256,0,0,1,9.426,8.8H10.85v2.372a.791.791,0,1,0,1.581,0V7.216a2.635,2.635,0,1,1,5.27,0H13.486V8.8H17.7v2.372a.791.791,0,1,0,1.581,0V7.216A4.228,4.228,0,0,0,15.067,3Z",
    transform: "translate(-6.227 -3)",
    fill: "#6e6e72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ShoppingBag);
export default __webpack_public_path__ + "static/media/icons8-shopping-bag.417ebb17.svg";
export { ForwardRef as ReactComponent };